exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctt-card-wrap.intro-deck{margin-top:20px;margin-left:0;margin-right:0;max-width:280px;cursor:pointer}.ctt-card-wrap.intro-deck .ctt-card{background:#ee2e24;border:none}.ctt-card-wrap.intro-deck .ctt-card__cont{display:flex;align-items:center;justify-content:center;min-height:290px}.ctt-card-wrap.intro-deck .ctt-card__cont h3{align-self:center;color:#fff}.intro-deck:after,.intro-deck:before{background-color:#ee2e24;border-radius:10px}", ""]);

// exports
